module.exports = __webpack_public_path__ + "img/Dixie-Creek.f01dab98.png";